import { createContext } from "react";

export interface IGiftPPIContext {
    giftPPIFlags: {
        giftPPI: boolean;
    };
    setGiftPPIFlags: ({}: { giftPPI: boolean }) => void;
}

const initialValue: IGiftPPIContext = {
    giftPPIFlags: { giftPPI: false },
    setGiftPPIFlags: () => void 0,
};

const GiftPPIContext = createContext(initialValue);

export default GiftPPIContext;
